import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
  delay?: number;
  className?: string;
  as?: "div" | "section" | "li" | "article" | "span";
};

/**
 * Presentational scroll-reveal wrapper.
 * Animation is CSS-only (view() timeline) so this stays hydration-free.
 */
export function Reveal({ children, delay = 0, className = "", as = "div" }: Props) {
  const Tag = as as "div";
  return (
    <Tag
      style={delay ? { animationDelay: `${delay}ms` } : undefined}
      className={`reveal ${className}`}
    >
      {children}
    </Tag>
  );
}
